const TEST_USER_EMAILS = [
  'lars+e2e@vrplatform.app',
  'lars+e2e-gl@vrplatform.app',
  'e2e-sign-up-legacy@vrp.rocks',
  'e2e-sign-up@vrp.rocks',
  'e2e-sign-up-partner@vrp.rocks',
  'e2e-invite-owner@vrp.rocks',
  'e2e-invite-member@vrp.rocks',
];

export const useIsPlaywright = (userEmail: string) => {
  return TEST_USER_EMAILS.includes(userEmail);
};
